// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router';
import ElementUI from 'element-ui';
import PicZoom from 'vue-piczoom'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import VuePhotoZoomPro from "vue-photo-zoom-pro";
import Qs from 'qs'
import axios from 'axios'
import store from './store/index.js'
import api from './api' //导入api接口
import {VueJsonp} from 'vue-jsonp'
Vue.use(VueJsonp)

Vue.config.productionTip = false
Vue.prototype.$api = api

Vue.use( VuePhotoZoomPro );
Vue.use( ElementUI );
/* eslint-disable no-new */
new Vue(
{
    router,
    store,
    el: '#app',
    render: h => h( App )
} ).$mount( App )